"use client";
import type { CSSProperties } from "react";
import type { SurveyQuestion, ContentTextOptions } from "@/types/survey";

interface ContentTextBlockProps {
  question: SurveyQuestion;
}

export default function ContentTextBlock({ question }: ContentTextBlockProps) {
  const opts = (question.options || {}) as ContentTextOptions;

  if (!question.text) return null;

  return (
    <div style={{ maxWidth: opts.maxWidth || "100%" }}>
      <p
        style={{
          // Inherit the survey theme's text color (light or dark) when no
          // explicit color is set, instead of forcing dark text on dark
          // backgrounds.
          color: opts.textColor || "currentColor",
          fontSize: opts.fontSize || "16px",
          fontWeight: opts.fontWeight || "normal",
          textAlign: (opts.textAlign as CSSProperties["textAlign"]) || "left",
          lineHeight: 1.6,
          whiteSpace: "pre-wrap",
          margin: 0,
        }}
      >
        {question.text}
      </p>
    </div>
  );
}
